document.querySelector('[data-language-selector]').addEventListener('click', function() {
  const content = document.querySelector('[data-language-selector-content]');  
  if (content.style.display === 'none' || !content.style.display) {
    content.style.display = 'flex';
  } else {
    content.addEventListener('transitionend', function handler() {
      content.style.display = 'none';
      content.removeEventListener('transitionend', handler);
    });
  }
});
const countrySelector = document.querySelector('[data-country-selector]');
const countryBtn = document.querySelector('[data-country-btn]');
countryBtn.href = `https://jp.nonfiction-beauty.com/`;
countrySelector.addEventListener('change', function() {
  const selectedValue = this.value;
  countryBtn.href = selectedValue;
});
document.querySelector('[data-language-close]').addEventListener('click', function() {
  document.querySelector('[data-language-selector-content]').style.display = 'none';
});